import { useSnackbar } from "notistack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DenseAppBar from "../../components/AppBar";
import Input from "../../components/Input";
import AlertModal from "../../components/Modal";
import { truncateString } from "../../helpers/Functions";
import { Reducers, Status } from "../../Interfaces/Interfaces";
import {
  fileUpload,
  getBanks,
  getFormStateAction,
  getLgaAction,
  getRegionAction,
  getRegionStateAction,
  getRegionTerritoryAction,
} from "../../redux/actions/configActions";
import { getAreasByState, getStates } from "../../redux/actions/LocationAction";
import { Icon } from "@material-ui/core";
import PrimaryTheme from "../../Themes/Primary";
import OtpInput from "react-otp-input";
import ExistingAgents from "../../components/ExistingAgents";
import { onboardAgents } from "../../redux/actions/AgentActions";
import StatusAlert from "../../components/StatusAlert";
import { resolveAccount } from "../../redux/actions/FundsTransferActions";
import { onboardAggregatorAction } from "../../redux/actions/AggregatorAction";
import ExistingAggregator from "../../components/ExistingAggregator";

export default function NewAggregator() {
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);
  const states = useSelector((state: Reducers) => state.states);
  const areas = useSelector((state: Reducers) => state.areas);
  const file = useSelector((state: Reducers) => state.file);
  const banks = useSelector((state: Reducers) => state.banks);
  const accountName = useSelector((state: Reducers) => state.generic);
  const getFormState = useSelector((state: any) => state.getFormState);

  const getLGAS = useSelector((state: any) => state.getLGAS);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [newAgent, setNewAgent] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const [gender, setGender] = React.useState("male");
  const [firstnameValid, setFirstnameValid]: any = React.useState(null);
  const [lastnameValid, setLastnameValid]: any = React.useState(null);
  const [dob, setDob]: any = React.useState("");
  const [email, setEmail] = React.useState("");
  const [confirmEmail, setConfirmEmail] = React.useState("");
  const [isEmailValid, setEmailValid]: any = React.useState(null);
  const [isMatched, setIsMatched]: any = React.useState(null);
  const [submitted] = React.useState(false);
  const [firstName, setFirstname] = React.useState("");
  const [lastName, setLastname] = React.useState("");
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [phoneNumberValid, setPhoneNumberValid]: any = React.useState(null);
  const [confirmPhoneNumber, setConfirmPhoneNumber] = React.useState("");
  const [ConfirmPhoneNumberValid, setConfirmPhoneNumberValid]: any =
    React.useState(null);
  const [address, setAddress] = React.useState("");
  const [City, setCity] = React.useState("");

  const [stateId, setStateId] = React.useState("");
  const [lgaId, setLgaId] = React.useState("");
  const [BVN, setBVN] = React.useState("");
  const [meansOfIdentification, setMeansOfIdentification] =
    React.useState("Drivers License");
  const [id] = React.useState("");
  const [idName, setIdName] = React.useState("Choose file...");
  const [passportName, setPassportName] = React.useState("Choose file...");
  const [certificateOfIncorporation] = React.useState("");
  const [certificateOfIncorporationName, setcertificateOfIncorporationName] =
    React.useState("Choose file...");
  const [utilityName, setUtilityName] = React.useState("Choose file...");
  const [passport] = React.useState("");
  const [utility] = React.useState("");
  const [pin, setPin] = React.useState("");
  const [loading] = React.useState(false);
  const [businessName, setbusinessName] = React.useState("");
  const [companyRegistrationNumber, setcompanyRegistrationNumber] =
    React.useState("");
  const [bankId, setbankId] = React.useState("");
  const [accountNumber, setaccountNumber] = React.useState("");
  const [bankArray, setBankArray]: any = React.useState([]);
  const [addaccountName, setaddaccountName] = React.useState("");
  const [BankName, setBankName] = React.useState("");
  const [locationAdded, setlocationAdded]: any = React.useState([]);
  const handleBank = (bankId: any) => {
    setbankId(bankId);
    let findBank = banks.find((item) => item.id === parseInt(bankId));
    setBankName(findBank.name);
  };

  const getRegions = useSelector((state: any) => state.getRegions);

  const regionState = useSelector((state: any) => state.regionState);
  const regionTerritory = useSelector((state: any) => state.regionTerritory);
  const [getLoadedState, setgetLoadedState] = React.useState([]);
  const [getLoadedTerritory, setgetLoadedTerritory] = React.useState([]);
  const [RegionId, setRegionId] = React.useState("");
  const [newState, setnewState]: any = React.useState("");
  const [newTerritory, setnewTerritory]: any = React.useState("");
  const [inputList, setInputList]: any = React.useState([
    {
      Region: "",
      State: "",
      Territory: "",
      RegionName: "",
      stateName: "",
      territoryName: "",
      RegionState: [],
      RegionTerritory: [],
    },
  ]);
  const [RegionForm, setRegionForm]: any = React.useState("");
  const [FormState, setFormState]: any = React.useState("");
  const [newStatePush, setnewStatePush]: any = React.useState("");
  const [newRegionPush, setnewRegionPush]: any = React.useState("");
  const [StateForm, setStateForm]: any = React.useState("");
  const [FormLGA, setFormLGA]: any = React.useState("");

  const validateName = (text: any, type: any) => {
    // minimum of one character
    let reg = /^[a-zA-Z]{1,}$/;
    if (!reg.test(text)) {
      if (type === "firstname") {
        setFirstname(text);
        setFirstnameValid(false);
      } else {
        setLastname(text);
        setLastnameValid(false);
      }
    } else {
      if (type === "firstname") {
        setFirstname(text);
        setFirstnameValid(true);
      } else {
        setLastname(text);
        setLastnameValid(true);
      }
    }
  };

  const isEmailMatch = (text: string) => {
    setConfirmEmail(text);

    if (email === text) {
      setIsMatched(true);
    } else {
      setIsMatched(false);
    }
  };

  const isPhoneMatch = (text: string) => {
    setConfirmPhoneNumber(text);

    if (phoneNumber === text) {
      setConfirmPhoneNumberValid(true);
    } else {
      setConfirmPhoneNumberValid(false);
    }
  };

  const validateEmail = (text: string) => {
    // email pattern
    let reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/;
    if (!reg.test(text)) {
      setEmailValid(false);
      setEmail(text.toLowerCase());
    } else {
      setEmailValid(true);
      setEmail(text);
    }
  };

  const validatePhoneNumber = (text: string) => {
    // email pattern
    let reg = /^[0-9]{11,11}$/;
    if (!reg.test(text)) {
      setPhoneNumberValid(false);
      setPhoneNumber(text.toLowerCase());
    } else {
      setPhoneNumberValid(true);
      setPhoneNumber(text);
    }
  };

  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    // dispatch(getAgents(paginationConfig));
  };

  const handleFile = (e: any, type: string) => {
    let pic = e[0];
    let fd = new FormData();
    if (pic) {
      fd.append("imageUrl", pic);
      dispatch(fileUpload(fd, type));
      dispatch({
        type: "LOADING",
        payload: true,
      });
    }
  };

  // const handleOTP = (e: any) => {
  //   e.preventDefault();

  //   dispatch({
  //     type: "ALERT_MODAL",
  //     payload: true,
  //   });
  // };

  const handleState = (state: string) => {
    setStateId(state);
    dispatch(getAreasByState(state));
  };
  React.useEffect(() => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
  }, []);
  React.useEffect(() => {
    let data = {
      accountNumber,
      bankId,
    };
    if (accountNumber.length === 10) {
      dispatch(resolveAccount(data));
    }
  }, [accountNumber, bankId]);

  React.useEffect(() => {
    if (Object.entries(file).length !== 0) {
      switch (file.fileType) {
        case "id": {
          setIdName(file.fileName);
          break;
        }

        case "passport": {
          setPassportName(file.fileName);
          break;
        }

        case "utility": {
          setUtilityName(file.fileName);
          break;
        }
        case "certificateOfIncorporation": {
          setcertificateOfIncorporationName(file.fileName);
          break;
        }

        default:
          return;
      }
    }
  }, [file]);

  React.useEffect(() => {
    dispatch(getStates());
    dispatch(getBanks());
    dispatch(getRegionAction());
  }, [dispatch]);

  const closeModal = () => {
    setPage(1);
    dispatch({ type: "ALERT_MODAL", payload: false });
    dispatch({ type: "STATUS_ALERT", payload: false });
  };

  const closeAlert = () => {
    setPage(1);
    dispatch({ type: "STATUS_ALERT", payload: false });
    window.location.reload();
  };

  const getLocation = (data: any) => {
    setlocationAdded(data);
  };

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        setPin("");
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      } else {
        handleRefresh();

        setPin("");

        if (alert.message === "Successful") {
          setInputList([
            {
              Region: "",
              State: "",
              Territory: "",
              RegionName: "",
              stateName: "",
              territoryName: "",
              RegionState: [],
              RegionTerritory: [],
            },
          ]);
          dispatch({
            type: "STATUS_ALERT",
            payload: true,
          });
        }
        dispatch({
          type: "ALERT_MODAL",
          payload: false,
        });
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);
  const [LocationIndex, setLocationIndex]: any = React.useState(0);

  // handle input change
  const handleTerritoryChange = (e: any, index: any) => {
    setLocationIndex(index);
    inputList[index].Region = e.target.value;
    inputList[index].stateName = "";
    inputList[index].territoryName = "";
    getRegions.map((list: any) =>
      list.id === parseInt(e.target.value)
        ? (inputList[index].RegionName = list.name)
        : ""
    );
    dispatch(getRegionStateAction(e.target.value));
    dispatch(getRegionTerritoryAction(e.target.value));
  };

  const handleInputChange = (e: any, index: any) => {
    setnewState(e.target.value);

    inputList[index].RegionState.map((list: any) =>
      list.id === parseInt(e.target.value)
        ? (inputList[index].stateName = list.name)
        : ""
    );

    return (inputList[index].State = e.target.value);
  };
  const handleTerritoryInputChange = (e: any, index: any) => {
    setnewTerritory(e.target.value);
    inputList[index].RegionTerritory.map((list: any) =>
      list.id === parseInt(e.target.value)
        ? (inputList[index].territoryName = list.name)
        : ""
    );

    return (inputList[index].Territory = e.target.value);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index: any) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([
      ...inputList,
      {
        Region: "",
        State: "",
        Territory: "",
        stateName: "",
        RegionName: "",
        territoryName: "",
        RegionState: [],
        RegionTerritory: [],
      },
    ]);
  };

  React.useEffect(() => {
    setnewStatePush(regionState);
  }, [regionState]);

  React.useEffect(() => {
    setnewRegionPush(regionTerritory);
  }, [regionTerritory]);
  React.useEffect(() => {
    let tem_state = [...inputList];
    let tem_element = { ...tem_state[LocationIndex] };
    tem_element.RegionState = newStatePush;
    tem_state[LocationIndex] = tem_element;
    setInputList(tem_state);
  }, [newStatePush]);

  React.useEffect(() => {
    let tem_Region = [...inputList];
    let tem_elementR = { ...tem_Region[LocationIndex] };
    tem_elementR.RegionTerritory = newRegionPush;
    tem_Region[LocationIndex] = tem_elementR;
    setInputList(tem_Region);
  }, [newRegionPush]);

  React.useEffect(() => {
    if (RegionForm) {
      dispatch(getFormStateAction(RegionForm));
    }
  }, [RegionForm]);

  React.useEffect(() => {
    if (FormState) {
      dispatch(getLgaAction(FormState));
    }
  }, [FormState]);

  const handleOTP = (e: any) => {
    e.preventDefault();

    dispatch({
      type: "LOADING",
      payload: true,
    });

    dispatch({
      type: "ALERT_MODAL",
      payload: false,
    });
    // {
    //   "country": "string",
    //   "firstName": "string",
    //   "lastName": "string",
    //   "address": "string",
    //   "phoneNumber": "string",
    //   "email": "string",
    //   "bankVerificationNumber": "string",
    //   "identificationType": "string",
    //   "identificationDocumentUrl": "string",
    //   "logoUrl": "string",
    //   "city": "string",
    //   "birthday": "2021-07-04T16:07:26.296Z",
    //   "createPinUrl": "string",
    //   "utilityBill": "string",
    //   "gender": "string",
    //   "businessName": "string",
    //   "businessType": 1,
    //   "certificateOfIncorporation": "string",
    //   "companyRegistrationNumber": "string",
    //   "stateId": 0,
    //   "lgaId": 0
    // }
    const aggregator = {
      firstName: firstName,
      lastName: lastName,
      address: address,
      phoneNumber: phoneNumber,
      email: email,
      confirmationUrl: "https://dashboard.bankly.ng",

      birthday: dob,
      bankVerificationNumber: BVN,
      identificationType:
        meansOfIdentification === "" ? "" : meansOfIdentification,
      identificationDocumentUrl: idName === "Choose file..." ? "" : idName,
      logo: passportName === "Choose file..." ? "" : passportName,
      city: City,
      regionId: RegionForm,
      stateId: FormState,
      lgaId: FormLGA,
      gender: gender,
      utilityBill: utilityName === "Choose file..." ? "" : utilityName,
      businessName: businessName,
      cacCertificate:
        certificateOfIncorporationName === "Choose file..."
          ? ""
          : certificateOfIncorporationName,

      rcNumber: companyRegistrationNumber,

      locations: inputList.length
        ? inputList.map((list: any) => {
            return {
              id: 0,
              regionId: list.Region,
              stateId: list.State,
              territoryId: list.Territory,
            };
          })
        : [
            {
              id: 0,
              regionId: 0,
              stateId: 0,
              territoryId: 0,
            },
          ],
      superAggregatorId: user.id,
    };

    dispatch(onboardAggregatorAction(aggregator));
  };

  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar canGoBack onClick={() => history.goBack()} />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,
          minHeight: "100vh",
          height: "auto",
        }}
      >
        <div
          className="col-md-12 ml-auto mr-auto p-0"
          style={{
            backgroundColor: PrimaryTheme.white,
            height: "100vh",
            position: "relative",

            // zIndex: 1000,
          }}
        >
          <h1
            className="mb-5 agent-title"
            style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              textTransform: "uppercase",
              fontSize: PrimaryTheme.fontSizes?.subtitle,
              marginLeft: "20px",
            }}
          >
            New Aggregator
          </h1>

          <div className="row mb-5" style={{ paddingBottom: "100px" }}>
            <div className="col-md-12 mb-3">
              <div className="input-group mb-3 col-md-6 ml-auto mr-auto">
                <div className="input-group-prepend w-50">
                  <button
                    className={
                      newAgent
                        ? "btn btn-warning w-100 btn-lg"
                        : "w-100 btn-light border"
                    }
                    type="button"
                    style={{
                      borderRadius: "20px 0 0 20px",
                    }}
                    onClick={() => setNewAgent(!newAgent)}
                  >
                    <span className="button-name">Add New Aggregator</span>
                  </button>
                </div>

                <div className="input-group-append w-50">
                  <button
                    className={
                      !newAgent
                        ? "btn btn-warning w-100 btn-lg"
                        : "w-100 btn-light border"
                    }
                    type="button"
                    style={{
                      borderRadius: "0 20px 20px 0",
                    }}
                    onClick={() => setNewAgent(!newAgent)}
                  >
                    <span className="button-name">
                      Map Registered Aggregator
                    </span>
                  </button>
                </div>
              </div>
              {newAgent && (
                <h6
                  className="text-center"
                  style={{
                    fontFamily: PrimaryTheme.fonts?.LightFont,
                    color: PrimaryTheme.dark,
                  }}
                >
                  Register a new aggregator which would be mapped to your
                  aggregator account instantly
                </h6>
              )}
            </div>

            <div className="col-md-6 ml-auto mr-auto mb-5">
              <form noValidate>
                {newAgent && page === 1 && (
                  <React.Fragment>
                    <div className="form-group">
                      <label
                        htmlFor="firstname"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Firstname
                      </label>
                      <Input
                        type="text"
                        placeholder="Enter First Name"
                        autoComplete="firstname"
                        showIcon
                        required
                        id="firstname"
                        valid={firstnameValid}
                        value={firstName}
                        disabled={submitted}
                        inputMode="text"
                        onChange={(e) =>
                          validateName(e.target.value, "firstname")
                        }
                        isInput
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <div className="form-group mt-4">
                      <label
                        htmlFor="lastname"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Lastname
                      </label>
                      <Input
                        type="text"
                        placeholder="Enter Last Name"
                        autoComplete="lastname"
                        showIcon
                        required
                        id="lastname"
                        valid={lastnameValid}
                        value={lastName}
                        disabled={submitted}
                        inputMode="text"
                        onChange={(e) =>
                          validateName(e.target.value, "lastname")
                        }
                        isInput
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <div className="form-group mt-4">
                      <label
                        htmlFor="email"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Email Address
                      </label>
                      <Input
                        type="email"
                        placeholder="Enter Email Address"
                        autoComplete="email"
                        showIcon
                        required
                        id="email"
                        valid={isEmailValid}
                        value={email}
                        disabled={submitted}
                        inputMode="email"
                        onChange={(e) => validateEmail(e.target.value)}
                        isInput
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <div className="form-group mt-4">
                      <label
                        htmlFor="confirmEmail"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Confirm Email Address
                      </label>
                      <Input
                        type="email"
                        placeholder="Confirm Email Address"
                        autoComplete="email"
                        showIcon
                        required
                        id="confirmEmail"
                        valid={isMatched}
                        value={confirmEmail}
                        disabled={submitted}
                        inputMode="email"
                        onChange={(e) => isEmailMatch(e.target.value)}
                        isInput
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <div className="form-group mt-4">
                      <label
                        htmlFor="phoneNumber"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Phone Number
                      </label>
                      <Input
                        type="tel"
                        placeholder="Enter Phone Number"
                        autoComplete="phoneNumber"
                        showIcon
                        required
                        id="phoneNumber"
                        valid={phoneNumberValid}
                        value={phoneNumber}
                        disabled={submitted}
                        inputMode="tel"
                        onChange={(e) => validatePhoneNumber(e.target.value)}
                        isInput
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <div className="form-group mt-4">
                      <label
                        htmlFor="confirmPhoneNumber"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Confirm Phone Number
                      </label>
                      <Input
                        type="tel"
                        placeholder="Confirm Phone Number"
                        autoComplete="phoneNumber"
                        showIcon
                        required
                        id="confirmPhoneNumber"
                        valid={ConfirmPhoneNumberValid}
                        value={confirmPhoneNumber}
                        disabled={submitted}
                        inputMode="tel"
                        onChange={(e) => isPhoneMatch(e.target.value)}
                        isInput
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <div className="form-group mt-4">
                      <label
                        htmlFor="dob"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Date of Birth
                      </label>
                      <Input
                        type="date"
                        required
                        id="dob"
                        value={dob}
                        disabled={submitted}
                        onChange={(e) => setDob(e.target.value)}
                        isInput
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <div className="form-group mt-4">
                      <label
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Gender
                      </label>

                      <div className="input-group mb-3 col-md-12 ml-auto mr-auto">
                        <div className="input-group-prepend w-50">
                          <button
                            className={
                              gender === "male"
                                ? "btn btn-warning w-100 btn-lg"
                                : "w-100 btn-light border"
                            }
                            type="button"
                            style={{
                              borderRadius: "20px 0 0 20px",
                            }}
                            onClick={() => setGender("male")}
                          >
                            Male
                          </button>
                        </div>

                        <div className="input-group-append w-50">
                          <button
                            className={
                              gender === "female"
                                ? "btn btn-warning w-100 btn-lg"
                                : "w-100 btn-light border"
                            }
                            type="button"
                            style={{
                              borderRadius: "0 20px 20px 0",
                            }}
                            onClick={() => setGender("female")}
                          >
                            Female
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mt-5 col-md-8 ml-auto mr-auto">
                      <Input
                        onClick={() => setPage(2)}
                        type="submit"
                        isInput
                        value="Continue"
                        disabled={
                          !firstnameValid ||
                          !lastnameValid ||
                          !isEmailValid ||
                          !phoneNumberValid ||
                          !ConfirmPhoneNumberValid ||
                          dob.length === 0
                        }
                        style={{
                          background: PrimaryTheme.primary,
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.white,
                        }}
                        className="text-bold border-0"
                      />
                    </div>
                  </React.Fragment>
                )}

                {newAgent && page === 2 && (
                  <React.Fragment>
                    <div className="form-group">
                      <label
                        htmlFor="address"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Address
                      </label>
                      <Input
                        type="text"
                        placeholder="Enter Current Address"
                        autoComplete="address"
                        showIcon
                        required
                        id="address"
                        value={address}
                        disabled={submitted}
                        inputMode="text"
                        onChange={(e) => setAddress(e.target.value)}
                        isInput
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <div className="form-group">
                      <label
                        htmlFor="address"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        City
                      </label>
                      <Input
                        type="text"
                        placeholder="Enter Current City"
                        autoComplete="city"
                        showIcon
                        required
                        id="address"
                        value={City}
                        disabled={submitted}
                        inputMode="text"
                        onChange={(e) => setCity(e.target.value)}
                        isInput
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <div className="form-group">
                      <label
                        htmlFor="address"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Region
                      </label>

                      <select
                        className="custom-select"
                        value={RegionForm}
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          backgroundColor: "#F4F7FC",
                          borderRadius: 25,
                          border: "1px solid white",
                          padding: 15,
                          height: "auto",
                          boxShadow: "none",
                        }}
                        onChange={(e) => setRegionForm(e.target.value)}
                      >
                        <option value="">Select Region</option>
                        {getRegions.length === 0
                          ? ""
                          : getRegions.map((data: any) => (
                              <option value={data.id}>{data.name}</option>
                            ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label
                        htmlFor="address"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        State
                      </label>

                      <select
                        className="custom-select"
                        value={FormState}
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          backgroundColor: "#F4F7FC",
                          borderRadius: 25,
                          border: "1px solid white",
                          padding: 15,
                          height: "auto",
                          boxShadow: "none",
                        }}
                        onChange={(e) => setFormState(e.target.value)}
                      >
                        <option value="">Select State</option>
                        {getFormState.length === 0
                          ? ""
                          : getFormState.map((data: any) => (
                              <option value={data.id}>{data.name}</option>
                            ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label
                        htmlFor="address"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Local Government
                      </label>

                      <select
                        className="custom-select"
                        value={FormLGA}
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          backgroundColor: "#F4F7FC",
                          borderRadius: 25,
                          border: "1px solid white",
                          padding: 15,
                          height: "auto",
                          boxShadow: "none",
                        }}
                        onChange={(e) => setFormLGA(e.target.value)}
                      >
                        <option value="">Select State</option>
                        {getLGAS.length === 0
                          ? ""
                          : getLGAS.map((data: any) => (
                              <option value={data.id}>{data.name}</option>
                            ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label
                        htmlFor="bvn"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        BVN
                      </label>
                      <Input
                        type="text"
                        placeholder="Enter BVN"
                        autoComplete="text"
                        showIcon
                        required
                        id="bvn"
                        value={BVN}
                        disabled={submitted}
                        inputMode="text"
                        onChange={(e) => setBVN(e.target.value)}
                        isInput
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <div className="form-group">
                      <label
                        htmlFor="bvn"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Business Name
                      </label>
                      <Input
                        type="text"
                        placeholder="Enter Business Name"
                        autoComplete="text"
                        showIcon
                        required
                        id="bvn"
                        value={businessName}
                        disabled={submitted}
                        inputMode="text"
                        onChange={(e) => setbusinessName(e.target.value)}
                        isInput
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="bvn"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Company Registration Number
                      </label>
                      <Input
                        type="text"
                        placeholder="Enter Company Registration Number"
                        autoComplete="text"
                        showIcon
                        required
                        id="bvn"
                        value={companyRegistrationNumber}
                        disabled={submitted}
                        inputMode="text"
                        onChange={(e) =>
                          setcompanyRegistrationNumber(e.target.value)
                        }
                        isInput
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          background: "#F4F7FC",
                        }}
                      />
                    </div>

                    <div className="form-group">
                      <label
                        htmlFor="meansOfIdentification"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Means Of Identification
                      </label>
                      <select
                        className="custom-select"
                        value={meansOfIdentification}
                        onChange={(e) =>
                          setMeansOfIdentification(e.target.value)
                        }
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          color: PrimaryTheme.dark,
                          backgroundColor: "#F4F7FC",
                          borderRadius: 25,
                          border: "1px solid white",
                          padding: 15,
                          height: "auto",
                          boxShadow: "none",
                        }}
                      >
                        <option value="Drivers License">Drivers License</option>
                        <option value="International Passport">
                          International Passport
                        </option>
                        <option value="National ID">National ID</option>
                        <option value="Voters Card">Voters Card</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <h6
                        className="w-100"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Government ID
                      </h6>

                      <label
                        htmlFor="id"
                        style={{
                          color: PrimaryTheme.dark,
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          background: "#F4F7FC",
                          borderRadius: 25,
                          border: "1px solid white",
                          padding: 15,
                          height: "auto",
                          boxShadow: "none",
                          width: "100%",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="file"
                          placeholder="Upload Government ID"
                          id="id"
                          name="id"
                          value={id}
                          disabled={submitted}
                          onChange={(e) =>
                            handleFile(e.currentTarget.files, "id")
                          }
                          style={{
                            fontFamily: PrimaryTheme.fonts?.RubikLight,
                            color: PrimaryTheme.dark,
                            background: "#F4F7FC",
                            display: "none",
                          }}
                        />

                        <div className="row justify-content-between align-items-center m-0">
                          <span>{truncateString(idName, 30)}</span>
                          <span
                            className="badge badge-pill badge-warning p-2 pl-3 pr-3 btn-lg"
                            style={{
                              fontSize: PrimaryTheme.fontSizes?.normal,
                            }}
                          >
                            {idName !== "Choose file..." ? "Change" : "Upload"}
                          </span>
                        </div>
                      </label>
                    </div>

                    <div className="form-group">
                      <h6
                        className="w-100"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Passport
                      </h6>

                      <label
                        htmlFor="passport"
                        style={{
                          color: PrimaryTheme.dark,
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          background: "#F4F7FC",
                          borderRadius: 25,
                          border: "1px solid white",
                          padding: 15,
                          height: "auto",
                          boxShadow: "none",
                          width: "100%",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="file"
                          placeholder="Upload Passport"
                          id="passport"
                          value={passport}
                          disabled={submitted}
                          onChange={(e) =>
                            handleFile(e.currentTarget.files, "passport")
                          }
                          style={{
                            fontFamily: PrimaryTheme.fonts?.RubikLight,
                            color: PrimaryTheme.dark,
                            background: "#F4F7FC",
                            display: "none",
                          }}
                        />

                        <div className="row justify-content-between align-items-center m-0">
                          <span>{truncateString(passportName, 30)}</span>
                          <span
                            className="badge badge-pill badge-warning p-2 pl-3 pr-3 btn-lg"
                            style={{
                              fontSize: PrimaryTheme.fontSizes?.normal,
                            }}
                          >
                            {passportName !== "Choose file..."
                              ? "Change"
                              : "Upload"}
                          </span>
                        </div>
                      </label>
                    </div>
                    <div className="form-group">
                      <h6
                        className="w-100"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Certificate Of Incorporation
                      </h6>

                      <label
                        htmlFor="certificateOfIncorporation"
                        style={{
                          color: PrimaryTheme.dark,
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          background: "#F4F7FC",
                          borderRadius: 25,
                          border: "1px solid white",
                          padding: 15,
                          height: "auto",
                          boxShadow: "none",
                          width: "100%",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="file"
                          placeholder="Upload Certificate Of Incorporation"
                          id="certificateOfIncorporation"
                          value={certificateOfIncorporation}
                          disabled={submitted}
                          onChange={(e) =>
                            handleFile(
                              e.currentTarget.files,
                              "certificateOfIncorporation"
                            )
                          }
                          style={{
                            fontFamily: PrimaryTheme.fonts?.RubikLight,
                            color: PrimaryTheme.dark,
                            background: "#F4F7FC",
                            display: "none",
                          }}
                        />

                        <div className="row justify-content-between align-items-center m-0">
                          <span>
                            {truncateString(certificateOfIncorporationName, 30)}
                          </span>
                          <span
                            className="badge badge-pill badge-warning p-2 pl-3 pr-3 btn-lg"
                            style={{
                              fontSize: PrimaryTheme.fontSizes?.normal,
                            }}
                          >
                            {certificateOfIncorporationName !== "Choose file..."
                              ? "Change"
                              : "Upload"}
                          </span>
                        </div>
                      </label>
                    </div>

                    <div className="form-group">
                      <h6
                        className="w-100"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        Utility Bill
                      </h6>

                      <label
                        htmlFor="utility"
                        style={{
                          color: PrimaryTheme.dark,
                          fontFamily: PrimaryTheme.fonts?.RubikLight,
                          background: "#F4F7FC",
                          borderRadius: 25,
                          border: "1px solid white",
                          padding: 15,
                          height: "auto",
                          boxShadow: "none",
                          width: "100%",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="file"
                          placeholder="Upload Utility Bill"
                          id="utility"
                          value={utility}
                          disabled={submitted}
                          onChange={(e) =>
                            handleFile(e.currentTarget.files, "utility")
                          }
                          style={{
                            fontFamily: PrimaryTheme.fonts?.RubikLight,
                            color: PrimaryTheme.dark,
                            background: "#F4F7FC",
                            display: "none",
                          }}
                        />

                        <div className="row justify-content-between align-items-center m-0">
                          <span>{truncateString(utilityName, 30)}</span>
                          <span
                            className="badge badge-pill badge-warning p-2 pl-3 pr-3 btn-lg"
                            style={{
                              fontSize: PrimaryTheme.fontSizes?.normal,
                            }}
                          >
                            {utilityName !== "Choose file..."
                              ? "Change"
                              : "Upload"}
                          </span>
                        </div>
                      </label>
                    </div>
                    <div
                      style={{
                        width: "100%",
                      }}
                    >
                      <div>
                        Locations
                        {inputList.map((x: any, i: any) => {
                          return (
                            <div className="box row">
                              <div
                                style={{ marginBottom: "10px" }}
                                className="col-md col-12"
                              >
                                {x.RegionName}
                                <select
                                  className="custom-select"
                                  value={x.Region}
                                  name={"Region" + i}
                                  onChange={(e) => handleTerritoryChange(e, i)}
                                  style={{
                                    fontFamily: PrimaryTheme.fonts?.RubikLight,
                                    color: PrimaryTheme.dark,
                                    backgroundColor: "#F4F7FC",
                                    borderRadius: 25,
                                    border: "1px solid white",
                                    padding: 15,
                                    height: "auto",
                                    boxShadow: "none",
                                  }}
                                >
                                  <option value="">Select Region</option>
                                  {getRegions &&
                                    getRegions.map((list: any) => (
                                      <option value={list.id}>
                                        {list.name}
                                      </option>
                                    ))}
                                </select>
                              </div>

                              <div
                                style={{ marginBottom: "10px" }}
                                className="col-md col-12"
                              >
                                {x.stateName}
                                <select
                                  className="custom-select"
                                  value={x.State}
                                  name={"State" + i}
                                  onChange={(e) => handleInputChange(e, i)}
                                  style={{
                                    fontFamily: PrimaryTheme.fonts?.RubikLight,
                                    color: PrimaryTheme.dark,
                                    backgroundColor: "#F4F7FC",
                                    borderRadius: 25,
                                    border: "1px solid white",
                                    padding: 15,
                                    height: "auto",
                                    boxShadow: "none",
                                  }}
                                >
                                  <option value="">Select State</option>
                                  {x.RegionState.length === 0
                                    ? ""
                                    : x.RegionState.map((data: any) => (
                                        <option value={data.id}>
                                          {data.name}
                                        </option>
                                      ))}
                                </select>
                              </div>
                              <div className="col-md col-12">
                                {x.territoryName}
                                <select
                                  className="custom-select"
                                  value={x.Territory}
                                  name={"Territory" + i}
                                  onChange={(e) =>
                                    handleTerritoryInputChange(e, i)
                                  }
                                  style={{
                                    fontFamily: PrimaryTheme.fonts?.RubikLight,
                                    color: PrimaryTheme.dark,
                                    backgroundColor: "#F4F7FC",
                                    borderRadius: 25,
                                    border: "1px solid white",
                                    padding: 15,
                                    height: "auto",
                                    boxShadow: "none",
                                  }}
                                >
                                  <option value="">Select Territory</option>
                                  {x.RegionTerritory.length === 0
                                    ? ""
                                    : x.RegionTerritory.map((data: any) => (
                                        <option value={data.id}>
                                          {data.name}
                                        </option>
                                      ))}
                                </select>
                              </div>
                              <div className="btn-box">
                                {inputList.length !== 1 && (
                                  <Icon
                                    onClick={() => handleRemoveClick(i)}
                                    style={{
                                      color: PrimaryTheme.danger,
                                      fontSize: "35px",
                                      cursor: "pointer",
                                      marginTop: "10px",
                                    }}
                                  >
                                    delete_forever
                                  </Icon>
                                )}

                                {inputList.length - 1 === i && (
                                  <Icon
                                    onClick={handleAddClick}
                                    style={{
                                      color: PrimaryTheme.success,
                                      fontSize: "35px",
                                      cursor: "pointer",
                                      marginTop: "10px",
                                    }}
                                  >
                                    add_circle
                                  </Icon>
                                )}
                              </div>
                              <hr />
                            </div>
                          );
                        })}
                        {/* <div style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div> */}
                      </div>
                    </div>
                    <div className="form-group mt-5 col-md-8 ml-auto mr-auto text-center">
                      <Input
                        onClick={handleOTP}
                        type="button"
                        isInput
                        value="Continue"
                        disabled={
                          RegionForm.length === 0 ||
                          FormState.length === 0 ||
                          FormLGA.length === 0 ||
                          address.length === 0 ||
                          idName === "Choose file..." ||
                          meansOfIdentification.length === 0 ||
                          passportName === "Choose file..." ||
                          utilityName === "Choose file..." ||
                          businessName === "" ||
                          companyRegistrationNumber === ""
                        }
                        style={{
                          background: PrimaryTheme.primary,
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.white,
                        }}
                        className="text-bold border-0"
                      />
                      <button
                        className="btn btn-light"
                        onClick={() => setPage(1)}
                      >
                        Back
                      </button>
                    </div>
                  </React.Fragment>
                )}
              </form>

              {!newAgent && <ExistingAggregator />}
            </div>
          </div>
        </div>

        <AlertModal>
          <div className="col-md-12 p-5 text-center">
            <div className="col-md-12">
              <span
                className="badge-pill p-3 d-block col-7 ml-auto mr-auto"
                style={{
                  background: PrimaryTheme.warn,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                Enter PIN
              </span>
            </div>

            <p
              className="mt-3 mb-5"
              style={{
                fontFamily: PrimaryTheme.fonts?.RegularFont,
                fontSize: 18,
                color: PrimaryTheme.light,
              }}
            >
              Enter your 4 Digit Transaction PIN to confirm this registration
            </p>

            <div className="row m-0 justify-content-center align-items-center">
              <OtpInput
                value={pin}
                onChange={(e: any) => setPin(e)}
                numInputs={4}
                isInputNum
                shouldAutoFocus
                inputStyle={{
                  width: "45px",
                  height: "45px",
                  fontSize: "24px",
                  padding: 0,
                  textAlign: "center",
                  borderRadius: 10,
                  border: "1px solid",
                  borderColor: PrimaryTheme.primary,
                }}
                isInputSecure
                separator={<span className="mr-3"> </span>}
              />
            </div>

            <div className="form-group mt-5 mb-0">
              <Input
                onClick={handleOTP}
                type="button"
                isInput
                value={loading ? "Adding..." : "Add Aggregator"}
                disabled={pin.length === 0}
                style={{
                  background: PrimaryTheme.primary,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.white,
                }}
                className="text-bold border-0 col-md-6"
              />
              <button className="btn btn-light" onClick={closeModal}>
                Back
              </button>
            </div>
          </div>
        </AlertModal>

        <StatusAlert
          subtitle="An email has been sent to the new aggregator’s email provided. The email contains a default password which the aggregator is expected to update upon login."
          title={firstName + " On-boarded Successfully"}
          buttonTitle="Add Aggregator"
          backTitle="Back to dashboard"
          onClick={closeAlert}
          goBack={() => history.push("/dashboard")}
        ></StatusAlert>
      </div>
    </React.Fragment>
  );
}
